import { Logo } from "@src/shared/components/general/Logo";

export interface UnauthenticatedLayoutV2Props {
  children: React.ReactNode;
}

export function UnauthenticatedLayoutV2({
  children,
}: UnauthenticatedLayoutV2Props) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="flex h-11 items-center border-b border-border px-5">
        <Logo className="h-4" />
      </header>
      <div className="flex min-h-[calc(100vh-2.75rem)] items-center justify-center px-6 py-10">
        {children}
      </div>
    </div>
  );
}
